
import catalogService from './../catalog'

export default () => [
  catalogService.fetch("macro/Carreteras/business_cicle", { useStore: true }),
  catalogService.fetch("macro/Carreteras/status", { useStore: true }),
  catalogService.fetch('macro/Carreteras/process', { useStore: true }),
]


// WEBPACK FOOTER //
// ./src/services/prefetch/macroCarreteras.js